import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Fee Analytics — Owner
 * GET /fee-management/analytics?period=&classId=&sectionId=&academicYearId=
 */
export const getFeeAnalytics = async (params = {}) => {
  const res = await axiosInstance.get("/fee-management/analytics", { params });
  return res.data;
};

/**
 * Fee Analytics — Portal
 * GET /fee-portal/analytics?period=&classId=&sectionId=&academicYearId=
 */
export const getFeeAnalyticsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/fee-portal/analytics", { params });
  return res.data;
};
